<template>
    <div class="w-25 ps-2 pt-2 bg-white d-flex flex-column position-relative">
        <div class="d-flex align-items-center justify-content-between mb-1 pe-2">
            <h6 class="fw-bold m-0">Find Nearby Employees</h6>
            <div>
                <button class="btn text-primary fw-bold p-0 me-3" @click="clearNearbyEmpFilters()">Clear</button>
                <button class="btn text-primary fw-bold p-0" @click="closeNearbyEmpPanel()">Done</button>
            </div>
        </div>
        <div class="ai-line"></div>
        <section class="row pe-2">
            <div class="col-4 pe-0 ps-1">
                <div class="form-control border-0 text-dark my-2"><strong>Search</strong></div>
                <div class="form-control border-0 text-dark my-2"><strong>Distance</strong></div>
                <div class="form-control border-0 text-dark my-2"><strong>Credentials</strong></div>
            </div>
            <div class="col-8 ps-0">
                <div class="my-2">
                    <input class="form-control" placeholder="Search by Name" v-model="nearbyEmpSearchTerm" />
                </div>
                <div class="my-2">
                    <select class="form-select" v-model="nearbyEmpDistance">
                        <option :value="5">5 miles</option>
                        <option :value="10">10 miles</option>
                        <option :value="15">15 miles</option>
                        <option :value="20">20 miles</option>
                        <option :value="25">25 miles</option>
                    </select>
                </div>
                <div class="my-2 credentials-filter">
                    <MultiSelectFilter
                        :on-fetch="userCredentialsFetch"
                        :selectedItems="selectedCredentials"
                        v-on:selectedItemsUpdated="selectedItemsUpdated"
                        name="User Credentials"
                        ref="credentialsRef"
                    />
                </div>
            </div>
        </section>

        <section :class="`nearby-emp-list pe-1 ${userOs == 'Windows' ? 'custom-scrollbar' : ''}`">
            <div
                v-for="emp of nearbyEmpPanelList"
                :key="emp.UserDetails.id"
                :class="`nearby-emp-card mb-2 ${selectedNearbyEmp.id === emp.UserDetails.id ? 'selected' : ''}`"
                @click="highlightEmpPin(emp.UserDetails, emp.UserDetails.id)"
            >
                <div class="d-flex align-items-center justify-content-between">
                    <div class="fw-bold">
                        {{ emp.UserDetails.firstName }} {{ emp.UserDetails.lastName }} ({{
                            emp.UserDetails.credentials ? emp.UserDetails.credentials.split(",")[0] : "None"
                        }})
                    </div>
                    <button
                        v-if="selectedPatientVisit.UserId === emp.UserDetails.sourceUserId"
                        class="btn text-success p-0 fw-semibold"
                    >
                        Assigned
                    </button>
                    <button
                        v-else-if="isReassignAllowed"
                        class="btn text-primary p-0 fw-semibold btn-assign"
                        @click="scheduledVisit(emp.UserDetails.sourceUserId)"
                    >
                        Assign
                    </button>
                </div>
                <small class="text-muted">{{ emp.UserDetails.distance }} miles away</small>
                <div class="my-1">
                    D: {{ emp.VisitFrequencyDay }}v/{{ emp.VisitHoursDay }}hr W: {{ emp.VisitFrequencyWeek }}v/{{
                        emp.VisitHoursWeek
                    }}hr
                </div>
                <div class="d-flex align-items-center mb-1">
                    <ProductPill class="me-2" :product-id="getApplicationId(emp.UserDetails.application)" />
                    <div class="me-2 pill green-pill">Active</div>
                    <small class="text-muted fw-bold">{{ emp.UserDetails.agencyName }}</small>
                </div>
            </div>
            <div class="text-center py-2" ref="trigger" v-show="pageCount < totalPageCount && showLoading">
                <i class="fas fa-spinner fa-pulse fa-fw fa-2x"></i>
                <div>Loading...</div>
            </div>
            <div class="text-center py-2" v-if="pageCount >= totalPageCount && nearbyEmpPanelList.length">
                Showing {{ totalItemCount }} Employees
            </div>
            <div v-if="!nearbyEmpPanelList.length && !showLoading" class="nearby-emp-list pe-1">No employees found</div>
        </section>
        <div class="d-flex justify-content-end">
            <img class="pe-2" src="../../../../../../img/Axxess_Intelligence_logo_2.svg" alt="" />
            <button class="ai-premium-btn mx-2 mt-2 mb-1">Premium</button>
        </div>
        <div class="ai-line"></div>
    </div>

    <div class="flex-grow-1" id="NearbyEmp__VisitMap"></div>
</template>

<style src="./FindNearByEmployess.scss"></style>
<script lang="ts" src="./FindNearbyEmployees.ts"></script>
